import { Statsig } from "@/env/statsig/client";
import { syncUserGroups } from "@/services/cpaasService/syncUserGroups";
import {
  isMindtickleCourse,
  isXylemeSyndicateCourse,
} from "@/utils/validateUrl";

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function launchSyndicateContent(
  userStatus: any,
  redirectUrl: string
) {
  if (!redirectUrl) return;

  const email = userStatus?.email;
  const contentBundles = userStatus?.bundles?.entitlements?.map((ent: any) => ({
    content_bundle_id: ent.content_bundle_id,
    content_bundle_name: ent.content_bundle_name,
  }));

  const attemptSync = async () => {
    try {
      await syncUserGroups(email, contentBundles);
    } catch (error: any) {
      const is5xx =
        error?.response?.status >= 500 && error?.response?.status < 600;
      if (is5xx) {
        await delay(1500);
        return await syncUserGroups(email, contentBundles);
      }
      throw error;
    }
  };
  await attemptSync();
  globalThis.open(redirectUrl, "_blank", "noopener");
}

export async function shouldUseSyndicateLaunchFlow(
  courseOrResult: any
): Promise<boolean> {
  if (isXylemeSyndicateCourse(courseOrResult)) {
    return true;
  }

  if (!isMindtickleCourse(courseOrResult)) {
    return false;
  }

  return await Statsig.featureGate("ENABLE_MINDTICKLE_EXTERNAL_LAUNCH");
}
